// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C3XG","input":"styles_input__1eOdo"};